// Motion tokens (release 1.4.0). One small set of durations and curves for every animation in Summit Operations, so
// the whole site moves the same way. Animations change transform and opacity only — never width, height, top or left —
// so nothing on the page shifts while it moves (no layout shift, no jank on the shop-floor PCs).

/** Durations in milliseconds. "fast" matches the design system's 150 ms fade-in. */
export const DURATION = {
  instant: 0,
  fast: 150,
  base: 220,
  slow: 360,
  /** A value or row that changed on refresh: long enough to notice, short enough not to nag. */
  pulse: 1_400,
  /** Progress bars filling to their value. */
  fill: 700,
  /** Number tween. */
  count: 600
} as const;

/** Easing curves (CSS cubic-bezier strings), Material-style "standard / emphasised / exit". */
export const EASE = {
  standard: "cubic-bezier(0.2, 0, 0, 1)",
  emphasized: "cubic-bezier(0.3, 0, 0, 1)",
  exit: "cubic-bezier(0.4, 0, 1, 1)",
  linear: "linear"
} as const;

/** The gap between items that enter one after another (stagger), and the most any item ever waits. */
export const STAGGER_MS = 40;
export const STAGGER_MAX_MS = 320;

/** Delay for the n-th item of a staggered list, capped so a long list never takes seconds to appear. */
export function staggerDelay(index: number, step: number = STAGGER_MS, max: number = STAGGER_MAX_MS): number {
  if (!Number.isFinite(index) || index <= 0) return 0;
  return Math.min(Math.round(index * step), max);
}

/** Cubic ease-out used by JavaScript tweens (AnimatedNumber, progress) so they match EASE.standard closely. */
export function easeOutCubic(t: number): number {
  const c = Math.min(1, Math.max(0, t));
  return 1 - Math.pow(1 - c, 3);
}
